define('LNRS/Components/Forms/EloquaGeneral',["jquery", "eventManager", "Components/Forms/EloquaMasterForm"], function ($, eventManager, eMasterForm) {
    var timerId = null, timeout = 20;

    function EloquaGeneral(args) {
        if (args.isEditing) {
            return;
        } else {
            WaitUntilCustomerGUIDIsRetrieved();
            if (typeof _elqQ !== 'undefined' && _elqQ !== null) {
                _elqQ.push(['elqGetCustomerGUID']);
            }

            if ($('input[name="QueryString"]').val() == '' && window.location.search != '') {
                $('input[name="QueryString"]').val(window.location.search);                
            }

            var trmid = getCookie('trmid');
            if (!trmid) {
                const queryStringValue = $('input[name="QueryString"]').val();

                if (queryStringValue && queryStringValue.trim() !== "") {
                    const params = new URLSearchParams(queryStringValue);
                    trmid = params.get("trmid");
                }
            }

            var treatmentIdField = $('#' + args.formId).find('[name="TreatmentId"]');
            if (treatmentIdField.length > 0) {
                if (trmid.length > 0) {
                    treatmentIdField.val(trmid);
                    if (args.dynamicAttribution) {
                        var sodCampaignArray = trmid.split('.', 4);
                        if (sodCampaignArray[3]) {
                            $('#' + args.formId).find('[name="SodCampaignNumber"]').val(trmid);
                        }
                        else {
                            var sodCampaignResult = sodCampaignArray[0] + '.' + sodCampaignArray[1] + '.' + sodCampaignArray[2];
                            $('#' + args.formId).find('[name="SodCampaignNumber"]').val(sodCampaignResult);
                        }
                    }
                } else {
                    var $form = $('#' + args.formId);
                    var defaultTreatmentIdField = $form.find('[name="DefaultTreatmentId"]');

                    if (defaultTreatmentIdField.length > 0) {
                        var defaultVal = (defaultTreatmentIdField.val() || '').trim();
                        if (defaultVal !== '') {
                            treatmentIdField.val(defaultVal);
                            $form.find('[name="SodCampaignNumber"]').val(defaultVal);
                        }
                    }
                }
                
            }

            //LNRSSUP-991
            var cRmLeadSourceOneField = $('#' + args.formId).find('[name="CRMLeadSourceOne"]');
            var leadSourceDetailOne = $('#' + args.formId).find('[name="LeadSourceDetailOne"]');
            var createdDateOne = $('#' + args.formId).find('[name="CreatedDateOne"]');

            if (createdDateOne.length > 0) {
                var currentDate = new Date(Date.now());
                var year = currentDate.getFullYear().toString();
                var month = (('' + currentDate.getMonth() + 1).length < 2 ? '0' : '') + (currentDate.getMonth() + 1);
                var day = (('' + currentDate.getDay()).length < 2 ? '0' : '') + currentDate.getDay();
                var date = (('' + currentDate.getDate()).length < 2 ? '0' : '') + currentDate.getDate();
                var hour = (('' + currentDate.getHours()).length < 2 ? '0' : '') + currentDate.getHours();
                var minute = (('' + currentDate.getMinutes()).length < 2 ? '0' : '') + currentDate.getMinutes();
                var second = (('' + currentDate.getSeconds()).length < 2 ? '0' : '') + currentDate.getSeconds();
                var miliSec = (('' + currentDate.getMilliseconds()).length < 2 ? '0' : '') + currentDate.getMilliseconds();
                var submissionDate = month + '/' + date + '/' + year + ' ' + hour + ':' + minute;
                $('#' + args.formId).find('[name="CreatedDateOne"]').val(submissionDate);
            }
           
            if (cRmLeadSourceOneField.length > 0 && leadSourceDetailOne.length > 0) {
                if (trmid.length > 0) {
                    var digitCodeArray = trmid.split('.');
                    var digitCodeResult = digitCodeArray[3];

                    var digitCodeKey = '';
                    if (digitCodeResult && digitCodeResult.length >= 4) {
                        digitCodeKey = digitCodeResult.substring(0, 4);
                    }
                    var dictResult = '';
                    var myDataObj = JSON.parse(args.fourDigitCodes);
                   
                    $.each(myDataObj, function (k, v) {
                        if (k === digitCodeKey.toUpperCase()) {
                            dictResult = v;
                        }
                    });
                   
                    if (dictResult.length > 0) {
                        var leadValues = dictResult.split(',');
                        if (leadValues.length > 0) {
                            var leadValue0 = typeof leadValues[0] !== 'undefined' ? leadValues[0].trim() : '';
                            var leadValue1 = typeof leadValues[1] !== 'undefined' ? leadValues[1].trim() : '';
                            $('#' + args.formId).find('[name="CRMLeadSourceOne"]').val(leadValue0);
                            $('#' + args.formId).find('[name="LeadSourceDetailOne"]').val(leadValue1);

                        }
                    }
                   
                    
                }
            }
            // LNRSSUP-991

            //Task : LNRSSUP-1871 Commenting below code for to permanently hide AreaOfInterest field and clear pre-selected area of AreaOfInterest field.

            var areaOfInterest = $('#' + args.formId).find('[name="AreaOfInterest"]');
            if (areaOfInterest.length > 0) {
                $(areaOfInterest).val("");
            }

            //// LNRSSUP-1069 & 1079 - Business Services Forms
            //if (trmid.length > 0) {
            //    var areaOfInterest = $('#' + args.formId).find('[name="AreaOfInterest"]');
            //    var isEloquaMasterForm = $(args.scope).find(".lnrs-form.eloqua-master-form").length > 0;
            //    var isBusinessServiceMediaAssetForm = $(args.scope).find(".lnrs-form.business-services-media-asset-form").length > 0;

            //    if (areaOfInterest.length > 0 && args.treatmentMSIDToAreaOfInterestMap) {

            //        var treatmentMSIDKey = trmid.split('.')[0].replace(/[^a-z]/gi, '').slice(0, 6).toUpperCase();
            //        var treatmentMSIDValue = args.treatmentMSIDToAreaOfInterestMap[treatmentMSIDKey];

            //        if (treatmentMSIDValue === undefined || treatmentMSIDValue === "Show solution of interest field") {
            //            // LNRSSUP-1133 - Skip displaying logic of area of interest for Eloqua Master form
            //            if (!isEloquaMasterForm && !isBusinessServiceMediaAssetForm) {
            //                $(areaOfInterest).parents(".area-of-interests").removeClass("hidden");
            //            }

            //            if (!isBusinessServiceMediaAssetForm) {
            //                $(areaOfInterest).val("");
            //            }

            //        }
            //        else {
            //            if (!isBusinessServiceMediaAssetForm) {
            //                $(areaOfInterest).val(treatmentMSIDValue).change();
            //            }
            //            else if ($(areaOfInterest).val() == null) {
            //                $(areaOfInterest).val(treatmentMSIDValue).change();
            //            }

            //            // LNRSSUP-1133 - Skip displaying logic of area of interest for Eloqua Master form
            //            if (!isEloquaMasterForm) {
            //                $(areaOfInterest).parents(".area-of-interests").addClass("hidden");
            //            }
            //        }
            //    }
            //}


            // LNRSSUP-1069 & 1079 - Business Services Forms

            //LNRSSUP-549
            eventManager.subscribe("SuccessAsset" + args.formId, function () {
                if (typeof _satellite !== 'undefined' && _satellite !== null && typeof _satellite.track === 'function') {
                    console.log('gatedasset');
                    _satellite.track('gatedasset');
                } else {
                    console.log('Track function on _stellite object not available!');
                }
            });
            //LNRSSUP-549
            eventManager.subscribe("SuccessContactUs" + args.formId, function () {
                if (typeof _satellite !== 'undefined' && _satellite !== null && typeof _satellite.track === 'function') {
                    console.log('contactussubmit');
                    _satellite.track('contactussubmit');
                } else {
                    console.log('Track function on _stellite object not available!');
                }
            });

        }
    }

    function getCookie(name) {
        var value = "; " + document.cookie;
        var parts = value.split("; " + name + "=");
        if (parts.length == 2) return parts.pop().split(";").shift();
        return '';
    }

    function elqGetGuidCookieValue() {
        var name, value, index, cookies = document.cookie.split(';');
        for (var i = 0; i < cookies.length; i++) {
            index = cookies[i].indexOf('=');
            if (index > 0 && cookies[i].length > index + 1) {
                name = cookies[i].substr(0, index).trim();
                if (name == 'ELOQUA') {
                    value = cookies[i].substr(index + 1);
                    var subCookies = value.split("&");
                    for (var l = 0; 1 < subCookies.length; l++) {
                        var subCookie = subCookies[l].split("=");
                        if (subCookie.length == 2 && subCookie[0] == 'GUID') {
                            return subCookie[1];
                        }
                    }
                }
            }
        }
        return '';
    }

    window.WaitUntilCustomerGUIDIsRetrieved = function WaitUntilCustomerGUIDIsRetrieved() {
        var cookieGUID = elqGetGuidCookieValue();
        if (cookieGUID.length > 0) {
            console.log('Customer GUID: ' + cookieGUID);
            $(document.forms).find('[name=elqCustomerGUID]').val(cookieGUID);
            return;
        }

        if (!!(timerId)) {
            if (timeout == 0) {
                return;
            }
            if (typeof this.GetElqCustomerGUID === 'function') {
                var eloqCustomerGUID = GetElqCustomerGUID();
                console.log('Customer GUID: ' + eloqCustomerGUID);
                $(document.forms).find('[name=elqCustomerGUID]').val(eloqCustomerGUID);
                return;
            }
            timeout -= 1;
        }
        timerId = setTimeout("WaitUntilCustomerGUIDIsRetrieved()", 500);
        return;
    }

    return function init(args) {
        if (!args.isEditing) {
            eMasterForm(args);
        }
        return new EloquaGeneral(args);
    };
});
